import styled from 'styled-components';
import { Alert, Button } from 'react-bootstrap';
import { ErrorBoundary, useErrorBoundary } from 'react-error-boundary';

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: grid;
  place-items: center;
  min-height: 25vh;
  background: rgba(255, 255, 255, 0.8);

  pre {
    border: 0;
    color: #ddd;
    background-color: #21324e;
    padding: 1.2rem 1.3rem;
    margin-top: 1.5rem;
    white-space: normal;
  }

  .alert {
    max-width: 35%;
  }
`;

function FallbackUI({ error }) {
  const { resetBoundary } = useErrorBoundary();
  const msg = error?.message || error?.data?.message;
  return (
    <Wrapper>
      <Alert variant="danger">
        <Alert.Heading>Error</Alert.Heading>
        <p>
          We encountered an issue while loading this form.
          Please try again.
        </p>
        <Button variant="light" size="sm" onClick={resetBoundary}>Try Again</Button>
        {msg && <pre>{msg}</pre>}
      </Alert>
    </Wrapper>
  );
}

export default function FormError({ children }) {
  return (
    <ErrorBoundary FallbackComponent={FallbackUI} onError={console.error}>
      {children}
    </ErrorBoundary>
  );
}
